import { NavLink } from "react-router-dom";
import { Wallet, Image, Settings, Sparkles, LayoutGrid } from "lucide-react";

const MobileNav = () => {
  const navItems = [
    { icon: Wallet, label: "Wallet", path: "/wallet" },
    { icon: LayoutGrid, label: "Experiences", path: "/experiences" },
    { icon: Image, label: "Portfolio", path: "/portfolio" },
    { icon: Settings, label: "Prefs", path: "/preferences" },
    { icon: Sparkles, label: "Inspo", path: "/inspirations" },
  ];

  return (
    <nav className="mobile-nav lg:hidden" data-testid="mobile-nav">
      <div className="glass rounded-full px-2 py-2 flex justify-around items-center w-full shadow-lg">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 px-3 py-2 rounded-full transition-colors duration-200 ${
                isActive
                  ? "bg-black text-white"
                  : "text-gray-400 hover:text-black"
              }`
            }
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            <item.icon className="w-5 h-5" strokeWidth={1.5} />
            <span className="text-[10px] font-medium">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default MobileNav;
